import { Modal, Row, Col, DropdownButton, Dropdown, Button, Badge } from "react-bootstrap";
import { getVisualStatusNFCe, NFCeDto } from "../../NFCe.Dto";

interface Props {
  show: boolean;
  nfce: NFCeDto | undefined;
  onReturn: () => void;
  onDelete: (value: NFCeDto) => void;
  onPrint: (value: NFCeDto) => void;
  onDownloadXml: (value: NFCeDto) => void;
  onFetchStatus: (value: NFCeDto) => void;
  onSend: (value: NFCeDto) => void;
  onDownloadDanfe: (value: NFCeDto) => void;
  onShareDanfe: (value: NFCeDto) => void;
}

const NFCeModalPropriedadesView = (props: Props) => {
  const finalizada = props.nfce?.autorizacao?.codigoStatusResposta === 100;
  const statusEnvio = props.nfce?.autorizacao?.codigoStatusEnvio;
  const aguardandoEnvio = statusEnvio === 0;
  const aguardandoRetorno = statusEnvio === 1;
  const visual = props.nfce ? getVisualStatusNFCe(props.nfce) : null;

  const onVisualizarHandler = () => {
    if (props.nfce) {
      window.open(`/fiscal/nfce/consulta/${props.nfce.id}/visualizar`, "_blank");
    }
  };

  const onReturnHandler = () => {
    if (props.nfce) {
      props.onReturn();
    }
  };

  const onDeleteHandler = () => {
    if (props.nfce) {
      props.onReturn();
      props.onDelete(props.nfce);
    }
  };

  const onPrintHandler = () => {
    if (props.nfce) {
      props.onPrint(props.nfce);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.nfce) {
      props.onDownloadXml(props.nfce);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.nfce) {
      props.onFetchStatus(props.nfce);
    }
  };

  const onSendHandler = () => {
    if (props.nfce) {
      props.onSend(props.nfce);
    }
  };

  const onDownloadDanfe = () => {
    if (props.nfce) {
      props.onDownloadDanfe(props.nfce);
    }
  };

  const onShareDanfe = () => {
    if (props.nfce) {
      props.onShareDanfe(props.nfce);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFCe: {props.nfce?.numeroNF}</Col>
            <Col xs={6}>Serie: {props.nfce?.serie}</Col>
          </Row>
          {visual && (
            <Row className="my-2">
              <Col xs={12}>
                <Badge
                  bg={visual.badgeBg}
                  text={visual.badgeText}
                  className="px-2 py-1 fs-7 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                >
                  <span>{visual.iconSymbol}</span>
                  <span>{visual.label}</span>
                </Badge>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12}>
              Status Envio: {props.nfce?.autorizacao?.codigoStatusEnvio}-
              {props.nfce?.autorizacao?.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.nfce?.autorizacao?.codigoStatusResposta}-
              {props.nfce?.autorizacao?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {finalizada && (
            <>
              <DropdownButton
                variant="outline-primary"
                title="DANFE"
                id="dropdown-imprimir"
                className="messagebox-btn-cancel"
              >
                <Dropdown.Item onClick={onPrintHandler}>
                  Imprimir agora
                </Dropdown.Item>

                <Dropdown.Item onClick={onShareDanfe}>
                  Compartilhar
                </Dropdown.Item>
                <Dropdown.Item onClick={onDownloadDanfe}>Baixar</Dropdown.Item>
              </DropdownButton>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onDownloadXmlHandler}
              >
                Baixar XML
              </Button>
            </>
          )}
          {!finalizada && aguardandoEnvio && (
            <>
              <Button
                variant="outline-danger"
                className="messagebox-btn-cancel"
                onClick={onDeleteHandler}
              >
                Excluir
              </Button>

              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onSendHandler}
              >
                Enviar
              </Button>
            </>
          )}
          {!finalizada && aguardandoRetorno && (
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onFetchStatusHandler}
            >
              Consultar Situação
            </Button>
          )}

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onVisualizarHandler}
          >
            Visualizar
          </Button>

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onReturnHandler}
          >
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NFCeModalPropriedadesView;
